import { render, staticRenderFns } from "./AutocompleteAcademicLevel.vue?vue&type=template&id=3be46582&scoped=true"
import script from "./AutocompleteAcademicLevel.vue?vue&type=script&lang=js"
export * from "./AutocompleteAcademicLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be46582",
  null
  
)

export default component.exports